'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('mail-list', {
      url: '/mail/:type/list',
      template: '<mail-list></mail-list>'
    });
}



// WEBPACK FOOTER //
// ./client/app/messaging/mail/list/mail-list.routes.js